export default __webpack_public_path__ + "assets/images/pay_third.1ae3c8.webp";